var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlan1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 41.4171,
    height: 41.4171,
    rx: 20.7086,
    fill: "#356C37"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5715 12.08L13.8864 21.302C13.5855 21.6632 13.435 21.8438 13.4327 21.9963C13.4307 22.1289 13.4897 22.255 13.5929 22.3384C13.7115 22.4342 13.9466 22.4342 14.4167 22.4342H20.7086L19.8458 29.3371L27.5308 20.115C27.8318 19.7538 27.9823 19.5733 27.9846 19.4207C27.9866 19.2882 27.9275 19.162 27.8244 19.0787C27.7058 18.9828 27.4707 18.9828 27.0006 18.9828H20.7086L21.5715 12.08Z",
    stroke: "white",
    strokeWidth: 1.72571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlan1);
export default __webpack_public_path__ + "static/media/plan1.ca7bf2db36cf52aee0dcdfa25a389c55.svg";
export { ForwardRef as ReactComponent };